<article class="feed-card-container">

    <div class="flex w-full min-w-0 flex-row items-start justify-between gap-3">

        <div class="flex min-w-0 flex-1 items-center">
            <div class="shrink-0">
                <div
                    class="size-12 rounded-lg flex items-center justify-center bg-cyan-50 dark:bg-cyan-900/30 dark:pill-cyan-900/30">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6 text-cyan-500">
                        <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
                        <path
                            d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09" />
                        <path
                            d="M9 12a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2z" />
                        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 .05 5 .05" />
                    </svg>
                </div>
            </div>
            <div class="ml-3 min-w-0 flex-1">
                <h3 class="text-base font-semibold text-primary">Auto Pilot <span class="text-orange-500">Disabled!</span></h3>
                <p class="text-sm text-secondary">
                    The Auto Pilot has been disabled. We will not act autonomously on this brief.
                </p>
            </div>
        </div>

        <div class="flex shrink-0 flex-col items-start justify-start h-full">

            <p class="text-sm text-secondary">
                {{ formatService.getTimeSinceUpdated(activity.date) }}
            </p>
        </div>

    </div>

    <div class="rounded-md bg-orange-50 p-4 dark:bg-orange-500/10 dark:outline dark:outline-orange-500/20">
        <div class="flex">
          <div class="shrink-0">
            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5 text-orange-400">
              <path d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clip-rule="evenodd" fill-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-orange-800 dark:text-orange-300">Successfully disbaled Auto-Pilot</p>
          </div>
          <div class="ml-auto pl-3">
          </div>
        </div>
      </div>
      
</article>